import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { Field } from 'redux-form';

import TextField from 'components/fields/TextField';

const ClaimsFilterSearch = ({ width,className }) => (
  <Grid
    className={className}
    container
    justify="flex-start"
    alignItems="center"
    spacing={width === 'xs' || width === 'sm' ? 0 : 24}
    wrap="nowrap"
  >
    <Grid
      item
      xs={12}
    >
      <Field
        id="Patient Name / Patient ID"
        name="Patient Name / Patient ID"
        type={width === 'xs' || width === 'sm' ? 'text' : 'search'}
        component={TextField}
        placeholder="Patient Name or PRN"
        fullWidth
      />
    </Grid>
  </Grid>
);

ClaimsFilterSearch.propTypes = {
  className: PropTypes.string,
};

ClaimsFilterSearch.defaultProps = {
  className: '',
};

export default ClaimsFilterSearch;



// WEBPACK FOOTER //
// ./src/components/reports/ClaimsFilter/ClaimsFilterSearch.js